import styled from 'styled-components';

export const Wrapper = styled.section``;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.gray15};
  white-space: pre-wrap;
  margin-bottom: 24px;
`;

export const Description = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.gray100};
  white-space: pre-wrap;
  margin-bottom: 56px;
`;

export const InputLabel = styled.div`
  color: ${({ theme }) => theme.palette.gray25};
  font-weight: 500;
`;
